var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, IsInt, IsString } from 'class-validator';
export class ManfrediteLinkedinImportReponse {
}
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], ManfrediteLinkedinImportReponse.prototype, "id", void 0);
__decorate([
    IsInt(),
    __metadata("design:type", Number)
], ManfrediteLinkedinImportReponse.prototype, "profileId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ManfrediteLinkedinImportReponse.prototype, "username", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ManfrediteLinkedinImportReponse.prototype, "source", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ManfrediteLinkedinImportReponse.prototype, "status", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ManfrediteLinkedinImportReponse.prototype, "errorType", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ManfrediteLinkedinImportReponse.prototype, "uuid", void 0);
__decorate([
    IsArray(),
    __metadata("design:type", Array)
], ManfrediteLinkedinImportReponse.prototype, "fieldsFilled", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ManfrediteLinkedinImportReponse.prototype, "step", void 0);
//# sourceMappingURL=manfredite-linkedin-import.response.js.map